import LoginForm from '../components/Landing/LoginForm';
import Navbar from '../components/Landing/Navbar';
import Landing from '../components/Landing/Landing';

const Login = () => {
    return (
        <div className="page-landing">
            <Navbar />
            <div className="subpage-landing">
                <div className="section-landing">
                    <Landing />
                </div>
                <div className="section-registration">
                    <LoginForm />
                </div>
            </div>
        </div>
    );
};

export default Login;
